import { contentWithData } from './content';
import { UserDynamicValues } from 'types/user';

const BOLD_REGEX = /\*(.*?)\*/g;
const LINK_REGEX = /\[([^\]]+)\]\(([^)\s]+)\)/g;

export const cueAsHTML = (cue: VTTCue, state: UserDynamicValues) => {
  const wrapper = document.createElement('div');
  wrapper.appendChild(cue.getCueAsHTML());

  const processed = wrapper.innerHTML
    .replace(BOLD_REGEX, '<strong>$1</strong>')
    .replace(
      LINK_REGEX,
      '<a href="$2" target="_blank" rel="noopener noreferrer">$1</a>'
    );
  return contentWithData(processed, state);
};
